import {useQuery} from '@tanstack/react-query';

import {GetListOutput, QueryOptionsForList} from '@shared/api';
import {getUserDeposits, GetUserPaymentsParams} from '../api';
import {QUERY__USER_DEPOSITS} from '../queryKeys';
import {Transaction} from '../types';

export const useGetUserDeposits = <SelectedData = GetListOutput<Transaction>>(
  params: GetUserPaymentsParams,
  options?: QueryOptionsForList<Transaction, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__USER_DEPOSITS, params],
    queryFn: () => getUserDeposits(params),
    ...options,
  });
};
